import axios from "axios";

function firstErrorText(value: unknown): string | null {
  if (typeof value === "string") {
    const text = stripHtml(value);
    return text || null;
  }
  if (Array.isArray(value)) {
    for (const item of value) {
      const text = firstErrorText(item);
      if (text) return text;
    }
  }
  if (value && typeof value === "object") {
    const record = value as Record<string, unknown>;
    return (
      firstErrorText(record.message) ??
      firstErrorText(record.detail) ??
      firstErrorText(record.error) ??
      firstErrorText(record.errors) ??
      firstErrorText(record.non_field_errors) ??
      firstErrorText(record.email) ??
      firstErrorText(record.new_password) ??
      firstErrorText(record.confirm_password)
    );
  }
  return null;
}

function stripHtml(value: string): string {
  return value.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

export function parseSdAuthApiError(err: unknown): string {
  if (!axios.isAxiosError(err)) {
    return err instanceof Error && err.message.trim()
      ? err.message
      : "Something went wrong. Please try again.";
  }

  if (!err.response) {
    return (
      err.message?.trim() ||
      "Could not reach the server. Please try again."
    );
  }

  const fromBody = firstErrorText(err.response.data);
  if (fromBody) {
    if (/password validation failed/i.test(fromBody)) {
      return `${fromBody}. Use 8 to 10 characters with upper and lower case letters, a number, and a special character. Do not use your name.`;
    }
    return fromBody;
  }

  if (err.response.status >= 500) {
    return "Something went wrong. Please try again.";
  }

  return (
    err.message?.trim() || "Something went wrong. Please try again."
  );
}
